var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('cursor-fx',{attrs:{"color":"#ffffff","color-hover":"#F5D579","inside-size":"10px","outside-size":"70px"}}),_c('NavBar'),_c('v-main',[_c('MainView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }